import React from "react";

import styled from "@mui/material/styles/styled";

import TableCell from "@app/analytics/components/Table/TableCell";
import SourceIcon from "@app/analytics/MeetingReports/components/SourceIcon";
import Thumbnail from "@app/analytics/MeetingReports/components/Thumbnail";
import type { Report } from "@app/analytics/MeetingReports/types";
import { isTopicReport } from "@app/analytics/MeetingReports/utils";
import * as SessionUtils from "@app/common/utils/sessionUtils";

import { Column, Row } from "@rui/Stack";

const MultiSourceWrapper = styled(Row)({
  "& > div:not(:first-of-type)": {
    marginLeft: "-2px",
  },
});

const Wrapper = ({
  asCell,
  children,
}: {
  asCell: boolean;
  children: React.ReactNode;
}) => {
  if (asCell) {
    return (
      <TableCell
        align="center"
        sx={{
          width: "68px", // 60px for the thumbnail + 8px padding
          maxWidth: "68px",
          alignContent: { xxs: "start", mobile: "center" },
        }}
      >
        {children}
      </TableCell>
    );
  }
  return <React.Fragment>{children}</React.Fragment>;
};

const SourceCell = ({
  report,
  asCell = true,
}: {
  report: Report;
  asCell?: boolean;
}) => {
  if (isTopicReport(report)) {
    return (
      <Wrapper asCell={asCell}>
        <Column variant="center" width="60px">
          {report.provider === "multi" ? (
            <MultiSourceWrapper variant="center" flexWrap="wrap">
              {report.channelProviders.map((provider) => (
                <SourceIcon
                  key={provider}
                  size={report.channelProviders.length > 2 ? "sm" : "md"}
                  source={provider}
                />
              ))}
            </MultiSourceWrapper>
          ) : (
            <SourceIcon size="lg" source={report.provider} />
          )}
        </Column>
      </Wrapper>
    );
  }

  return (
    <Wrapper asCell={asCell}>
      <Column variant="center" width="60px">
        <Thumbnail
          src={report.thumbnailUrl}
          platform={
            SessionUtils.isUploadedSession(report)
              ? "upload"
              : report.meetingPlatform
          }
        />
      </Column>
    </Wrapper>
  );
};

export default SourceCell;
